import {useTranslation} from "react-i18next";
import {useEffect, useRef, useState, useContext} from "react";
import {useNavigate} from "react-router-dom";
// -
import NavBreadcrum from "components/NavBreadcrum";
import TopBarActions from "components/TopBarActions";
import MainTableTemplates from "./dynamic/MainTableTemplates";
import ButtonsActions from "../utils/buttonsActions";
import navs from "./navs";
import axiApi from "ApiCaller";
import AuthContext from "context/AuthContext";

import {SwalAlertClass, SwalAlertChoice} from "core/swalClass";
import LoaderSpinner from "context/LoaderSpinner";
import FilterModel from "components/FilterModel";
import TopBarPagination from "components/paginator/TopBarPagination-v2";
import {PagerModel} from "components/paginator/PaginationModel";
import OrderingModel from "components/ordering/OrderingModel";
import ItemsModel from "core/itemsModel";
import useCustomTranslation from "core/customTranslation";
import translations from "./dynamic/translations";

const ViewDynamic = () => {
    const {user} = useContext(AuthContext);
    const navigate = useNavigate();
    const {t: _Tr} = useTranslation("routes");
    const {t: _Tt} = useTranslation("tags");
    const {t: _CT} = useCustomTranslation(translations);
    const Alert = new SwalAlertClass({confirmButtonText: "Aceptar"});
    const AlertQuestion = new SwalAlertChoice({
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
    });
    document.title = _Tr("labels.routes-dynamic");
    const TBbuttons = useRef(new ButtonsActions());
    const [buttonsTB, setButtonsTB] = useState({
        ...new ButtonsActions(),
        title: document.title,
    });

    const items = useRef(new ItemsModel());
    const filters = useRef(new FilterModel());
    const pagerModelRef = useRef(new PagerModel());
    const orderingRef = useRef(new OrderingModel());

    const [, setShowPrev] = useState(false);
    const [itemsShown, setItemsShown] = useState([]);
    const [, setItem] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [checkAll, setCheckAll] = useState(false);

    const bread = [
        {
            name: _Tr("labels.route-management"),
            url: "/route-management/",
            current: false,
        },
        {name: _Tr("labels.routes-dynamic"), current: true},
    ];

    const headersTable = [
        {name: _Tt("common.name"), attr: 0, direction: "asc", active: true, default: true},
        {name: _Tt("common.description"), attr: 1, direction: "asc", active: false},
        {name: _Tt("common.origin"), attr: 2, direction: "asc", active: false},
        {name: _Tt("common.destination"), attr: 3, direction: "asc", active: false},
        {name: _Tt("common.fraction"), attr: 4, direction: "asc", active: false},
        {name: _Tt("common.download"), attr: 5, direction: "asc", active: false},
        {name: _Tt("common.actives"), attr: 6, direction: "asc", active: false, disabled: true},
        {name: _Tt("common.c1"), attr: 7, direction: "asc", active: false, disabled: true},
        {name: _Tt("common.c2"), attr: 8, direction: "asc", active: false, disabled: true},
        {name: _Tt("common.c3"), attr: 9, direction: "asc", active: false, disabled: true},
        {name: _Tt("common.days"), attr: 10, direction: "asc", active: false, disabled: true},
        {name: _Tt("common.forced"), attr: 11, direction: "asc", active: false, disabled: true},
        {name: _Tt("common.duration"), attr: 12, direction: "asc", active: false, disabled: true},
    ];

    useEffect(() => {
        // Verificar si el usuario es administrador
        const canEdit = user && (user.is_superuser || user.is_admin);

        TBbuttons.current.title = document.title;

        // Solo activar botones para administradores
        TBbuttons.current.add.active = canEdit;
        TBbuttons.current.add.disabled = !canEdit;
        TBbuttons.current.add.onClick = clickAdd;

        TBbuttons.current.edit.active = canEdit;
        TBbuttons.current.edit.disabled = true;
        TBbuttons.current.edit.onClick = onClickEdit;

        TBbuttons.current.duplicate.active = canEdit;
        TBbuttons.current.duplicate.disabled = true;
        TBbuttons.current.duplicate.onClick = onClickDuplicate;

        TBbuttons.current.delete.active = canEdit;
        TBbuttons.current.delete.disabled = true;
        TBbuttons.current.delete.onClick = clickDelete;

        setButtonsTB({...TBbuttons.current});
        pagerModelRef.current.active = true;
        pagerModelRef.current.handleCallApi = () => {
            fetchRoutes();
        };
        orderingRef.current.setHeaders(headersTable);
        orderingRef.current.applyOrder = () => fetchRoutes();
        items.current.setItem = setItem;
        items.current.setShowPrev = setShowPrev;
        items.current.item = {};
        fetchGetRoutes();
    }, []);
    filters.current.filter = () => {
        pagerModelRef.current.paging.page = 1;
        fetchRoutes();
    };

    const fetchGetRoutes = () => {
        setIsLoading(true);
        axiApi
            .get("/api/distribution/dynamic/routes/")
            .then((resp) => {
                items.current.showed = [...resp.data.items];
                setItemsShown([...resp.data.items]);
                if (resp.data.pager) {
                    pagerModelRef.current.paging.update(resp.data.pager);
                }
            })
            .catch((error) => {
                console.error("Error al enviar la solicitud:", error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const fetchRoutes = () => {
        setIsLoading(true);
        axiApi
            .post("/api/distribution/dynamic/routes/", filters.current.chosen, {
                params: {...pagerModelRef.current.paging.getParams(), ...orderingRef.current.getParams()},
            })
            .then((resp) => {
                items.current.setShowed(resp.data.items);
                setItemsShown([...resp.data.items]);
                if (resp.data.pager) {
                    pagerModelRef.current.paging.update(resp.data.pager);
                }
            })
            .catch((error) => {
                console.error("Error al enviar la solicitud:", error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const clickAdd = () => {
        navigate("/route-management/routes-dynamic/template/add/");
    };

    const onClickEdit = () => {
        if (items.current.chosen.length > 1 || items.current.chosen.length === 0) {
            return false;
        }
        navigate(`/route-management/routes-dynamic/template/${items.current.chosen[0]}/`);
    };

    const onClickDuplicate = () => {
        if (items.current.chosen.length !== 1) {
            return false;
        }
        const route = items.current.showed.find((item) => item.id === items.current.chosen[0]);
        axiApi
            .post("/api/distribution/dynamic/route/duplicate/", {
                id: route.id,
                name: `${route.name} ${_CT("duplicate-suffix")}`,
            })
            .then((resp) => {
                if (resp.data.status) {
                    Alert.success(_CT("duplicate-ok-title"), _CT("duplicate-ok-text"));
                    fetchRoutes();
                } else {
                    Alert.error(_CT("duplicate-error"));
                }
            })
            .catch((error) => {
                console.error(error);
                Alert.error(_CT("duplicate-error"));
            });
    };

    const clickDelete = () => {
        if (items.current.chosen.length === 0) {
            Alert.error("Error", "No hay elementos seleccionados para borrar.");
            return;
        }

        let ids = items.current.getChosenIds();

        axiApi
            .post(`/api/distribution/dynamic/route/check/`, {ids})
            .then((resp) => {
                if (resp.data.isInUse) {
                    AlertQuestion.warning(
                        "La ruta está en uso",
                        `La ruta está en uso en programación. ¿Desea eliminarla igualmente?`
                    ).then((r) => {
                        if (!r.isConfirmed) return;
                        setIsLoading(true);
                        proceedToDelete(ids);
                    });
                } else {
                    AlertQuestion.warning(
                        "Se eliminará",
                        `Se borrarán los ${items.current.chosen.length} dinámicos seleccionados`
                    ).then((r) => {
                        if (!r.isConfirmed) return;

                        proceedToDelete(ids);
                    });
                }
            })
            .catch((err) => {
                console.error(err);
                Alert.warning("Error en el servidor", "No se pudo verificar el uso.");
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const proceedToDelete = (ids) => {
        axiApi
            .delete("/api/distribution/dynamic/routes/", {data: {ids}})
            .then((resp) => {
                if (resp.data.status) {
                    // Filtrar y actualizar la lista
                    items.current.showed = items.current.showed.filter((item) => !ids.includes(item.id));
                    setItemsShown([...items.current.showed]);

                    // Limpiar checkboxes
                    items.current.checkBoxes.forEach((checkbox) => (checkbox.checked = false));
                    items.current.clearChosen();
                    // Deshabilitar botones
                    TBbuttons.current.edit.disabled = true;
                    TBbuttons.current.duplicate.disabled = true;
                    TBbuttons.current.delete.disabled = true;
                    setButtonsTB({...TBbuttons.current});
                }
            })
            .catch((error) => {
                console.error("Error al eliminar:", error);
                Alert.error("Error en el servidor", "Avisar al administrador");
            });
    };

    return (
        <>
            <NavBreadcrum navs={navs} bread={bread} />
            <TopBarActions actions={buttonsTB} filtersRef={filters} />
            <TopBarPagination pagerModel={pagerModelRef.current} stickyTopValue="125px" chosen={items.current.chosen} />
            <div className="row">
                <div className="col-md col-12">
                    <LoaderSpinner isLoading={isLoading}>
                        <MainTableTemplates
                            itemsShow={itemsShown}
                            checkAll={checkAll}
                            items={items}
                            setCheckAll={setCheckAll}
                            buttonsTB={buttonsTB}
                            setButtonsTB={setButtonsTB}
                            orderingRef={orderingRef}
                        />
                    </LoaderSpinner>
                </div>
            </div>
        </>
    );
};

export default ViewDynamic;
